var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgScrollArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8657 0.153809C11.6816 0.153809 12.3431 0.816772 12.3431 1.63458V18.7905L18.6855 12.4337C19.2624 11.8554 20.1979 11.8554 20.7748 12.4337C21.3518 13.0119 21.3518 13.9495 20.7748 14.5278L11.9104 23.4124C11.3334 23.9907 10.398 23.9907 9.821 23.4124L0.956528 14.5278C0.379562 13.9495 0.379562 13.0119 0.956528 12.4337C1.53349 11.8554 2.46894 11.8554 3.0459 12.4337L9.38827 18.7905V1.63458C9.38827 0.816772 10.0497 0.153809 10.8657 0.153809Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScrollArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/scrollArrow.6ef6d961.svg";
export { ForwardRef as ReactComponent };